import { render, staticRenderFns } from "./yek-teoriakoulutukset.vue?vue&type=template&id=65b5cbba&scoped=true&"
import script from "./yek-teoriakoulutukset.vue?vue&type=script&lang=ts&"
export * from "./yek-teoriakoulutukset.vue?vue&type=script&lang=ts&"
import style0 from "./yek-teoriakoulutukset.vue?vue&type=style&index=0&id=65b5cbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5cbba",
  null
  
)

export default component.exports